import { render, staticRenderFns } from "./NavbarDesktopTextSmallImageBlocks.vue?vue&type=template&id=3955829b&scoped=true&lang=pug&"
import script from "./NavbarDesktopTextSmallImageBlocks.vue?vue&type=script&lang=js&"
export * from "./NavbarDesktopTextSmallImageBlocks.vue?vue&type=script&lang=js&"
import style0 from "./NavbarDesktopTextSmallImageBlocks.vue?vue&type=style&index=0&id=3955829b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3955829b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3955829b')) {
      api.createRecord('3955829b', component.options)
    } else {
      api.reload('3955829b', component.options)
    }
    module.hot.accept("./NavbarDesktopTextSmallImageBlocks.vue?vue&type=template&id=3955829b&scoped=true&lang=pug&", function () {
      api.rerender('3955829b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/NavbarDesktopTextSmallImageBlocks.vue"
export default component.exports